// src/components/Courses.jsx
import {
  Box,
  Typography,
  Container,
  Card,
  CardContent,
  Chip,
  Button,
  Divider,
  Dialog,
  IconButton,
} from "@mui/material";
import { motion } from "framer-motion";
import DescriptionIcon from "@mui/icons-material/Description";
import CloseIcon from "@mui/icons-material/Close";
import courses from "../data/courses";
import { useState } from "react";

const Courses = () => {
  const [openCertificate, setOpenCertificate] = useState(null);

  const handleOpenCertificate = (certificateUrl) => {
    setOpenCertificate(certificateUrl);
  };

  const handleCloseCertificate = () => {
    setOpenCertificate(null);
  };
  return (
    <Box id="courses" sx={{ py: 8, bgcolor: "background.default" }}>
      <Container maxWidth="lg">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
        >
          <Typography variant="h4" gutterBottom align="center" sx={{ mb: 4 }}>
            Courses & Certifications
          </Typography>

          <Box
            sx={{
              display: "grid",
              gap: 4,
              gridTemplateColumns: {
                xs: "1fr",
                sm: "repeat(2, 1fr)",
                lg: "repeat(3, 1fr)",
              },
            }}
          >
            {courses.map((course, index) => (
              <motion.div
                key={index}
                whileHover={{ y: -5 }}
                transition={{ duration: 0.2 }}
              >
                <Card
                  elevation={3}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <CardContent sx={{ flexGrow: 1 }}>
                    <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
                      <DescriptionIcon color="primary" sx={{ mr: 1.5 }} />
                      <Typography variant="h6" component="h3">
                        {course.title}
                      </Typography>
                    </Box>
                    <Typography
                      variant="subtitle1"
                      color="text.secondary"
                      gutterBottom
                    >
                      {course.provider} • {course.date}
                    </Typography>

                    <Divider sx={{ my: 2 }} />

                    <Box sx={{ mb: 2 }}>
                      <Typography variant="body2" sx={{ mb: 1 }}>
                        Skills Gained:
                      </Typography>
                      <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}>
                        {course.skills.map((skill, i) => (
                          <Chip
                            key={i}
                            label={skill}
                            size="small"
                            variant="outlined"
                          />
                        ))}
                      </Box>
                    </Box>
                  </CardContent>

                  <Box sx={{ p: 2 }}>
                    <Button
                      fullWidth
                      variant="contained"
                      onClick={() =>
                        handleOpenCertificate(course.certificateUrl)
                      }
                      startIcon={<DescriptionIcon />}
                    >
                      View Certificate
                    </Button>
                  </Box>
                </Card>
              </motion.div>
            ))}
          </Box>
        </motion.div>
      </Container>

      {/* Certificate Modal - Full View No Scroll */}
      <Dialog
        open={!!openCertificate}
        onClose={handleCloseCertificate}
        fullScreen
        PaperProps={{
          sx: {
            backgroundColor: "#f5f5f5",
          },
        }}
      >
        <Box
          sx={{
            position: "relative",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            width: "100vw",
            height: "100vh",
            overflow: "hidden",
          }}
        >
          {/* Close Button */}
          <IconButton
            edge="end"
            onClick={handleCloseCertificate}
            aria-label="close"
            sx={{
              position: "absolute",
              top: 20,
              right: 20,
              zIndex: 10,
              backgroundColor: "#fff",
              color: "#000",
              width: 44,
              height: 44,
              boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
              "&:hover": {
                backgroundColor: "#fff",
                boxShadow: "0 4px 12px rgba(0,0,0,0.25)",
              },
              transition: "all 0.2s ease-in-out",
            }}
          >
            <CloseIcon sx={{ fontSize: 24 }} />
          </IconButton>

          {/* Content Container */}
          <Box
            sx={{
              width: "100%",
              height: "100%",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              overflow: "auto",
            }}
          >
            {openCertificate && openCertificate.endsWith(".pdf") ? (
              <iframe
                src={`${openCertificate}#toolbar=0&navpanes=0`}
                style={{
                  width: "100%",
                  height: "100%",
                  border: "none",
                }}
                title="Certificate"
              />
            ) : (
              <Box
                component="img"
                src={openCertificate}
                alt="Certificate"
                sx={{
                  maxWidth: "100%",
                  maxHeight: "100%",
                  objectFit: "contain",
                }}
              />
            )}
          </Box>
        </Box>
      </Dialog>
    </Box>
  );
};

export default Courses;
